// keycloak.js
let keycloakInstance = null

export function setKeycloak (instance) {
  keycloakInstance = instance
}

export function getKeycloak () {
  return keycloakInstance
}
